import { useParams } from "@reach/router";

export default function useReferralCodeParam() {
  const params = useParams();
  return params?.referralCode as string;
}
